export function addCurrent(slacounttype) {
    return {
        type: 'ADD_CURRENT',
        slacounttype,
    }
}
